import { logError } from '@/utils/logger';
const KEY = 'gbi:tenantName';
export function getTenantName() {
    return window.localStorage.getItem(KEY);
}
export function setTenantName(tenantName) {
    try {
        window.localStorage.setItem(KEY, tenantName);
    }
    catch (e) {
        logError('Could not store tenant name:', e);
    }
}
export function clearTenantName() {
    window.localStorage.removeItem(KEY);
}
